import { IProduct } from '@/types/Product.model';
import { IApp } from '@/types/App.model';

export const Listing = {
  Status: {
    LISTED: 'LISTED',
    PENDING: 'PENDING',
    UNLISTED: 'UNLISTED',
  },
  Confirmation: {
    DECLINED: 'DECLINED',
    PENDING: 'PENDING',
    CONFIRMED: 'CONFIRMED',
  },
  Population: {
    PRODUCT_FIELDS: [
      '_id',
      'productName',
      'productImage',
      'imageVersion',
      'articleNumber',
    ] as const,
    APP_FIELDS: ['_id', 'appName', 'logo'] as const,
  },
} as const;

export interface IListing extends Document {
  _id: string;
  product: string; // Reference to Product
  app: string; // Reference to App
  status: (typeof Listing.Status)[keyof typeof Listing.Status];
  appConfirmation: (typeof Listing.Confirmation)[keyof typeof Listing.Confirmation];
  productConfirmation: (typeof Listing.Confirmation)[keyof typeof Listing.Confirmation];
  createdAt: Date;
  updatedAt: Date;
  isConfirmed: boolean;
  isRejected: boolean;
}

export interface IPopulatedListing extends Omit<IListing, 'product' | 'app'> {
  product: Pick<IProduct, (typeof Listing.Population.PRODUCT_FIELDS)[number]>;
  app: Pick<IApp, (typeof Listing.Population.APP_FIELDS)[number]>;
}

export const getStatusColor = (status: string) => {
  switch (status) {
    case Listing.Status.PENDING:
      return 'yellow';
    case Listing.Status.LISTED:
      return 'green';
    case Listing.Status.UNLISTED:
      return 'red';
    default:
      return 'gray';
  }
};

export const getConfirmationColor = (confirmation: string) => {
  switch (confirmation) {
    case Listing.Confirmation.CONFIRMED:
      return 'green';
    case Listing.Confirmation.DECLINED:
      return 'red';
    case Listing.Confirmation.PENDING:
      return 'yellow';
    default:
      return 'gray';
  }
};
